<template>
    <div id="recent-accounts" v-if="this.userCan('view_dashboard_account_datatable', 'init')">
        <div class="recent-accounts-wrapper" v-if="loadingAccounts || hasRecentlyActiveAccounts">
            <div v-if="hasRecentlyActiveAccounts" class="columns component-header-actions">
                <div class="column">
                    <h4 class="title is-4">
                        <b-icon icon="briefcase" />
                        {{ init.user_settings.dashboard.dashboardAccounts.title }}
                    </h4>
                </div>
                <div class="column has-text-right" v-if="!loadingAccounts && userCan('create_accounts', 'accounts')">
                    <b-button v-if="!userCan('create_simple_accounts', 'accounts')"
                              tag="router-link"
                              type="is-primary"
                              class="has-icon"
                              icon-left="plus"
                              label="Start an Account"
                              :to="{path: '/accounts/create'}" />

                    <simple-account-button v-else />
                </div>
            </div>
            <div v-if="loadingAccounts || hasRecentlyActiveAccounts" class="account-rows-wrapper">

                <b-loading :is-full-page="false" :active.sync="loadingAccounts" :can-cancel="false">
                    <b-icon
                            pack="fas"
                            icon="sync-alt"
                            custom-class="fa-spin">
                    </b-icon>
                    <p>Please wait while we gather the account data...</p>
                </b-loading>

                <template v-if="!loadingAccounts">
                    <ul class="account-rows-header">
                        <li class="account-row-favorite"></li>
                        <li class="account-row-status">Status</li>
                        <li class="account-row-name">Account Name</li>
                        <li class="account-row-account">Account #</li>
                        <li class="account-row-data"></li>
                        <li class="account-row-buttons"></li>
                    </ul>
                    <account-row
                            v-for="account in accounts"
                            :key="`account-${account.id}`"
                            :account="account" />
                </template>
            </div>
        </div>

        <template v-if="!loadingAccounts && !hasRecentlyActiveAccounts && !anyAccounts">
            <div id="dashboard-welcome">
                <div id="dashboard-welcome-content">
                    <h1 class="m-b-30">Welcome! Ready to get Started?</h1>
                    <template v-if="userCan('create_accounts', 'accounts')">
                        <b-button v-if="!userCan('create_simple_accounts', 'accounts')"
                                  tag="router-link"
                                  type="is-primary"
                                  class="has-icon is-medium"
                                  icon-left="plus"
                                  label="Start an Account"
                                  :to="{path: '/accounts/create'}" />

                        <simple-account-button button-class="is-medium" v-else />
                    </template>
                </div>

                <div id="dashboard-welcome-bg-wrapper">
                    <div id="dashboard-welcome-bg"></div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AccountRow from './AccountRow'
import SimpleAccountButton from '../SimpleAccountButton'

export default {
  name: 'RecentlyActiveAccounts',
  props: ['accessible_accounts'],
  components: {
    AccountRow,
    SimpleAccountButton
  },
  computed: {
    ...mapState({
      init: state => state.init.all,
      accounts: state => state.accounts.recent,
      userSettings: state => state.userSettings,
      accountsInitialized: state => state.accounts.initialized,
      anyAccounts: state => state.accounts.any
    }),
    ...mapGetters({
      pusher: 'pusher/init',
      userCan: 'userCan'
    }),
    hasRecentlyActiveAccounts: function () {
      if (!this.accountsInitialized) return false
      return Object.keys(this.accounts).length > 0
    },
    loadingAccounts: function () {
      if (this.accountsInitialized) return false
      return !this.hasRecentlyActiveAccounts
    }
  },
  methods: {
    //
  },
  mounted () {
    //
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/Dashboard/RecentlyActive.vue